import api from '@/api'
import MonetarySearchRequest from '@/model/monetary/MonetarySearchRequest';
import AccountSearchRequest from '@/model/account/AccountSearchRequest';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAccountsByClient({ commit }, clientId) {
      return api.base()
        .get('/account/client/' + clientId)
        .then(
          response => {
            return response.data.data
          }
        )
    },
    getAllAccounts(actions, {
      filter,
      pagination,
      sort,
      cancelToken, // optional — the global search cancels its previous request
    }) {
      return api.base()
        .post('/account/get/all',
          AccountSearchRequest({
            ...(filter || {}),
            pagination,
            sort,
          }),
          cancelToken ? { cancelToken } : undefined
        )
        .then(response => (
          {
            data: response.data.data,
            pagination: {
              page: response.data.metadata.page,
              total: response.data.metadata.total
            },
            sort: response.data.metadata.sort
          })
        );
    },
    getAccountByLogin({ commit }, account) {
      return api.base()
        .get('/account/get/' + account)
        .then(
          response => {
            return response.data.data
          }
        )
    },
    getAccountDataByLogin({ commit }, account) {
      return api.base()
        .get('/account/data/' + account)
        .then(
          response => {
            commit("symbol/tickerUpdate", response.data.data.tickers, { root: true })
            return response.data.data
          }
        )
    },
    createAccount({ commit }, account) {
        return api.base()
            .post('/account/add', account)
            .then(
            response => {
                return response.data.data
            }
            )
    },
    setActive({ commit }, { account, active }) {
      return api.base()
        .put('/account/set/active/' + account, null, { params: { active } })
        .then(
          response => {
            return response.data.data
          })
    },
    setRestrictTrades({ commit }, { account, restrictTrades }) {
      return api.base()
        .put('/account/set/restrict-trades/' + account, null, { params: { restrictTrades } })
        .then(
          response => {
            return response.data.data
          })
    },
    syncReportAccount({ commit }, account) {
      return api.base()
        .get('/account/sync/report/' + account)
        .then(
          response => {
            return response.data.data
          })
    },
    syncAccount({ commit }, account) {
      return api.base()
        .put('/account/sync/' + account)
        .then(
          response => {
            return response.data.data
          })
    },
    deleteAccount({ commit }, account) {
      return api.base()
        .delete('/account/delete/' + account)
        .then(
          response => {
            return response.data.data
          })
    }
  }
}
